<div class="container-fluid main">


  <div class="row">
    <div class="row table_title mt-5 background-white w-100">
      <div class="row w-100 p-3 mx-5">
        <div class="col mx-5 px-5 title">
          <h3 class="my-4">{{ title }}</h3>
        </div>
        <div *ngIf="" class="col-6 px-2 w-100">
          <div class=" mx-5 px-5 w-100">
            <a
              routerLink="/create/{{ type }}"
              class="btn btn-primary btn-lg active mx-5 my-3 create_btn"
              role="button"
              aria-pressed="true"
              >New Account</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-center m-5 p-5 text-primary" *ngIf="!data">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div class="row table_col" *ngIf="data">
    <div class="col background-white py-2 px-5 ">
      <table class="table table-striped ">
        <thead w-100 class="table_head">
          <tr>
            <th scope="col">Names</th>
            <th scope="col">Phone Number</th>
            <th scope="col">Region</th>
            <th scope="col">District</th>
            <th scope="col">Parish</th>
            <th scope="col">Subcounty</th>
            <th scope="col">Village</th>
            <th scope="col">Value Chain</th>
            <th scope="col">Time Joined</th>
          </tr>
        </thead>
        <tbody p-5>
          <tr
            *ngFor="
              let row of data
                | paginate: { itemsPerPage: count, currentPage: page }
            "
          >
            <td>{{ row.test.farmer_name }}</td>
            <td>{{ row.test.farmer_phone_number }}</td>
            <td>{{ row.test.farmer_region }}</td>
            <td>{{ row.test.farmer_district }}</td>
            <td>{{ row.test.farmer_parish }}</td>
            <td>{{ row.test.farmer_subcounty }}</td>
            <td>{{ row.test.farmer_village }}</td>
            <td>{{ row.test.value_chain }}</td>
            <td>{{ row.test.time | date:'mediumDate' }}</td>
          </tr>
        </tbody>
      </table>
      <nav aria-label="Page navigation example">
        <pagination-controls (pageChange)="page = $event"></pagination-controls>
      </nav>
      <!-- Modal -->
      <div
        class="modal fade mt-5 p-5"
        id="exampleModalLong"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLongTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header" *ngIf="!actionSuccess">
              <h5 class="modal-title text-info" id="exampleModalLongTitle">
                {{ action }} Account
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <span *ngIf="actionSuccess && message">{{ message }}</span>
              <span *ngIf="!actionSuccess">
                <div *ngIf="!submitted; else spinnerDiv"></div>
                Are you sure you want to {{ action | lowercase }} this account?
              </span>
            </div>
            <div class="modal-footer">
              <div *ngIf="!actionSuccess">
                <button
                  type="button"
                  class="btn btn-danger mr-3"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary status ml-3"
                  (click)="changeStatus(selectedUser._id, action)"
                >
                  {{ action }} Account
                </button>
              </div>
              <div *ngIf="actionSuccess && message">
                <button
                  type="button"
                  class="btn btn-primary"
                  data-dismiss="modal"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-edit-modal
        [id]="id"
        [userId]="userId"
        [accountUrl]="url"
        *ngIf="id && userId"
        (EditAcct)="updateOnEdit()"
        (modalClose)="closeEditModal()"
      ></app-edit-modal>
      <div
        class="modal fade mt-5 p-5"
        id="csvModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="csvModalTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title text-info" id="csvModalTitle">
                Upload village agent list
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body csv-modal">
              <div *ngIf="(apiError !== null || apiSuccessMessage !== null) else spinnerDiv"></div>
              <h6>Please upload only Excel/CSV files</h6>
              <div *ngIf="apiError && apiError.status === 400" class="alert alert-danger" role="alert">
               {{apiError.error.error}}
              </div>
              <div
                *ngIf="apiError && !apiError.status"
                class="alert alert-danger"
                role="alert"
              >
                <div *ngFor="let error of apiError">
                  {{ error }}
                </div>
              </div>
              <div
                *ngIf="apiSuccessMessage"
                class="alert alert-success"
                role="alert"
              >
                {{ apiSuccessMessage.message }}
              </div>
              <p>
                <csv2json
                  [btnText]="'Browse'"
                  [errorMsg]="'Invalid file.'"
                  (response)="onUpload($event)"
                ></csv2json>
              </p>
            </div>
            <div class="modal-footer">
              {{ currentId }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-template #spinnerDiv>
      <div class="spinner d-flex justify-content-center text-primary">
        <span
          class="spinner-border spinner-border-md mx-auto"
          role="status"
        ></span>
      </div>
    </ng-template>
  </div>
</div>
